import React, { memo, ReactNode, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import cls from './DaData.module.css';
import { useDaData } from './useDaData';
import { Input } from '../Input/Input';
import { Icon } from '../Icon/Icon';

interface DaDataProps {
    classes?: string;
    value: string;
    label: string;
    inputName: string;
    onChange: (name: string, value: string) => void;
    maxLength: number;
    icon: ReactNode;
    placeholder?: string;
    errorMessage?: string;
    isSmartPosition?: boolean;
}

export const DaData = memo(
    ({
        classes,
        icon,
        maxLength,
        value,
        onChange,
        label,
        inputName,
        isSmartPosition = false,
    }: DaDataProps) => {
        const { onForm, companyList, isNotFound, onDaData } = useDaData(onChange, inputName);
        const rootRef = useRef<HTMLDivElement>(null);
        const [listStyle, setListStyle] = useState<React.CSSProperties>({});

        useEffect(() => {
            const calcRect = () => {
                if (!isSmartPosition) {
                    setListStyle({});
                    return;
                }

                if (!rootRef.current) return;

                const rect = rootRef.current.getBoundingClientRect();
                const spaceBelow = window.innerHeight - rect.bottom;
                const openUpward = spaceBelow < 170;

                setListStyle({
                    position: 'fixed',
                    top: openUpward ? rect.top - 8 : rect.bottom + 4,
                    left: rect.left,
                    width: rect.width,
                    transform: openUpward ? 'translateY(-100%)' : 'none',
                });
            };

            calcRect();

            window.addEventListener('resize', calcRect);
            window.addEventListener('scroll', calcRect, true);

            return () => {
                window.removeEventListener('resize', calcRect);
                window.removeEventListener('scroll', calcRect, true);
            };
        }, [companyList.length, isSmartPosition]);

        return (
            <div
                ref={rootRef}
                className={classNames(cls.DaData, [classes])}
                onClick={(e) => e.stopPropagation()}
            >
                <Input
                    value={value}
                    label={label}
                    errorMessage={''}
                    inputName={inputName}
                    onChange={onForm}
                    maxLength={maxLength}
                    icon={icon}
                />
                {!!companyList.length && (
                    <div className={cls.daDataList} style={listStyle}>
                        {companyList.map((company) =>
                            isNotFound(company) ? (
                                <div className={cls.notFound}>{company.message}</div>
                            ) : (
                                <>
                                    {inputName === 'bik' ? (
                                        <div
                                            className={classNames(cls.daDataItem, cls.bik)}
                                            onClick={() => onDaData(company)}
                                        >
                                            <div className={cls.name}>{company.name}</div>
                                        </div>
                                    ) : (
                                        <div
                                            className={cls.daDataItem}
                                            onClick={() => onDaData(company)}
                                        >
                                            <div className={cls.icon}>
                                                <Icon iconName={'location'} />
                                            </div>
                                            <div className={cls.full_name}>{company.full_name}</div>
                                            <div className={cls.inn}>{company.inn}</div>
                                            <div className={cls.legal_address}>
                                                {company.legal_address}
                                            </div>
                                        </div>
                                    )}
                                </>
                            )
                        )}
                    </div>
                )}
            </div>
        );
    }
);
